import dynamic from 'next/dynamic';

const ClientSide = dynamic(() => import('../components/ClientSide'), {
  ssr: false
});

export default function Home() {
  return <ClientSide />;
}